import {useContext} from "react";
import {Redirect, Route} from "react-router-dom";
import {default as Links} from "../Route";
import AuthenticationContext from "./AuthenticationContext";

const AuthenticatedRoute = ({path, component}) => {
    const {isAuthenticated} = useContext(AuthenticationContext);
    return isAuthenticated ? <Route exact path={path} component={component} /> : <Redirect to={Links.SignIn.link} />;
};

export default AuthenticatedRoute;